import { render } from "./App.vue?vue&type=template&id=5c8e325c"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=5c8e325c&lang=css"

import exportComponent from "D:\\山东佰域网络科技\\2.0版本\\new-sty-pcproject\\newStyProject\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__